export default __webpack_public_path__ + "static/media/fullscreen_exit.570c0018.svg";